module.exports = __webpack_public_path__ + "static/power1-1-b051211456e4d4cf61b6cde6dd031a0d.png";